import axios from "axios";
import { toast } from "react-toastify";
import {
  ADD_HL7_CONFIG,
  ADD_HL7_NODE,
  DELETE_HL7_NODE,
  GET_ALL_CONFIGS,
  GET_HL7_CONFIG,
  GET_HL7_NODES,
  GET_HL7_VERSIONS,
  GET_PUSHBACK_OPERATIONS,
  UPDATE_CURRENT_STATUS_HL7_CONFIG,
  UPDATE_HL7_NODE,
} from "../../appConstants";

const SIZE = 10;

export const addHL7Node = async (params) => {
  const { name, ip, port, version } = params;

  const data = {
    name,
    ip,
    port,
    version,
  };

  const config = {
    method: "post",
    url: ADD_HL7_NODE,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    if (response.data.success === true) {
      toast.success(`Success: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      toast.error(`Error: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    return response.data;
  } catch (error) {
    toast.error(`Error: ${"Something Went Wrong"}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};

export const getHL7Versions = async () => {
  const config = {
    method: "get",
    url: GET_HL7_VERSIONS,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getHL7configs = async (params) => {


  const data = {
    keyword: params?.keyword || "",
    sort_by: params?.sort_by || "",
    asc: params?.asc || true,
  };

  const config = {
    method: "post",
    url: `${GET_HL7_CONFIG}?page=${params?.page || 1}&size=${SIZE}`,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    toast.error(`Error: ${error.message}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};

export const getHL7Nodes = async (params) => {


  const data = {
    keyword: params?.keyword || "",
    sort_by: params?.sort_by || "",
    asc: params?.asc,
  };

  const config = {
    method: "post",
    url: `${GET_HL7_NODES}?page=${params?.page || 1}&size=${SIZE}`,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteHL7Node = async (id) => {
  const config = {
    method: "delete",
    url: `${DELETE_HL7_NODE}/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
  };


  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateHL7Node = async (params) => {
  const { name, ip, port, id, version } = params;

  const data = {
    name,
    ip,
    port,
    version,
    id,
  };

  const config = {
    method: "put",
    url: UPDATE_HL7_NODE,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    if (response?.data?.success === false) {
      toast.error(`Error: ${response?.data?.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      toast.success(`Success: ${response?.data?.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    return response.data;
  } catch (error) {
    toast.error(`Error: ${error.message}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};

export const addHL7Config = async (params) => {
  const data = {
    ...params,
  };

  const config = {
    method: "post",
    url: ADD_HL7_CONFIG,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    if (response?.data?.success === false) {
      toast.error(`Error: ${response?.data?.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      toast.success(`Success: ${response?.data?.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    return response.data;
  } catch (error) {
    toast.error(`Error: ${error.message}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};
export const updateCurrentStatusHl7config = async (params) => {
  const data = {
    ...params,
  };

  const config = {
    method: "post",
    url: UPDATE_CURRENT_STATUS_HL7_CONFIG,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    if (
      response.message ===
      "Could not set this configuration as this has got conflicts with other active configurations (Cannot set multiple active configurations receiving messages from the same RIS.)"
    ) {
      toast.error(`Error: ${response.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    return response.data;
  } catch (error) {
    toast.error(`Error: ${error.message}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};

export const getRouterConfigs = async () => {
  const config = {
    method: "post",
    url: `${GET_ALL_CONFIGS}`,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: {},
  };

  try {
    const response = await axios(config);
    return response.data?.items;
  } catch (error) {
    throw error;
  }
};

export const getPushbackOperations = async () => {
  const config = {
    method: "get",
    url: `${GET_PUSHBACK_OPERATIONS}`,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    throw error;
  }
};
